var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankOfAmericaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e31837",
    fillRule: "evenodd",
    d: "M23.928,37.011C31.507,30.514,42.153,24.199,48,21.925 c-0.902-0.578-2.31-1.408-3.898-2.31c-7.543,2.49-16.349,8.012-24.217,14.256C21.221,34.881,22.628,35.928,23.928,37.011 L23.928,37.011z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M20.463,19.363c-1.119-0.542-2.346-1.047-3.284-1.48 c-2.851,1.407-6.569,3.537-11.26,6.893c1.011,0.542,2.093,1.191,3.248,1.841C12.776,23.946,16.421,21.42,20.463,19.363z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e31837",
    fillRule: "evenodd",
    d: "M27.212,16.259c-1.372-0.758-6.135-2.527-9.42-3.284 c-0.974,0.361-2.346,0.902-3.284,1.299c1.191,0.325,5.63,1.516,9.42,3.429C24.902,17.233,26.274,16.656,27.212,16.259 L27.212,16.259z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M11.079,15.79C6.857,17.739,2.418,20.409,0,21.961 c0.866,0.397,1.732,0.722,2.923,1.299c5.341-3.609,9.528-5.811,11.188-6.532C12.92,16.294,11.801,16.006,11.079,15.79L11.079,15.79 z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e31837",
    fillRule: "evenodd",
    d: "M30.388,15.14c0.974-0.325,2.094-0.614,3.068-0.903 c-2.815-1.191-6.352-2.454-9.528-3.248c-0.505,0.144-2.021,0.542-3.068,0.866C21.943,12.181,25.515,13.011,30.388,15.14z M12.595,28.71c1.155,0.686,2.382,1.624,3.573,2.418c7.904-6.135,15.699-10.863,24.253-13.534 c-1.191-0.613-2.238-1.154-3.573-1.804C31.723,17.089,22.953,20.589,12.595,28.71L12.595,28.71z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankOfAmericaIcon);
export default __webpack_public_path__ + "static/media/bank-of-america-icon.abac99a5dd570f0807643009ccd9f177.svg";
export { ForwardRef as ReactComponent };